var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.2552 11.9424C9.31213 12.5671 8.18123 12.9308 6.96537 12.9308C3.67079 12.9308 1 10.26 1 6.9654C1 3.6708 3.67079 1 6.96537 1C10.26 1 12.9307 3.6708 12.9307 6.9654C12.9307 8.18123 12.567 9.3121 11.9424 10.2551L14.8253 13.138C15.0582 13.371 15.0582 13.7487 14.8253 13.9816L13.9816 14.8253C13.7487 15.0582 13.371 15.0582 13.138 14.8253L10.2552 11.9424ZM10.5446 6.9654C10.5446 8.94216 8.94212 10.5446 6.96537 10.5446C4.98862 10.5446 3.38615 8.94216 3.38615 6.9654C3.38615 4.98864 4.98862 3.38616 6.96537 3.38616C8.94212 3.38616 10.5446 4.98864 10.5446 6.9654Z","fill":"#9CA3AF"}));
}

Search.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Search;

Search.default = Search;
